import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { addQueueItem } from '../idb';
import { toast } from 'sonner';

export default function PortalDocuments() {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [file, setFile] = useState(null);
  const [docType, setDocType] = useState('CONTRACT');

  useEffect(() => { (async () => {
    try {
      const res = await axios.get('/projects');
      setProjects(res.data);
      if (res.data.length) setSelectedProject(res.data[0].id);
    } catch {}
  })(); }, []);

  const upload = async (e) => {
    e.preventDefault();
    if (!file || !selectedProject) return;
    const isOffline = !navigator.onLine;
    if (isOffline) {
      const item = { id: 'q-' + crypto.randomUUID(), type: 'document_upload', status: 'queued', createdAt: Date.now(), file: { name: file.name, blob: file }, meta: { project_id: selectedProject, doc_type: docType } };
      await addQueueItem(item);
      toast.success(t("documents.queuedDocumentUpload"));
      return;
    }
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('project_id', selectedProject);
      fd.append('doc_type', docType);
      await axios.post('/cycle3/documents/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success(t("documents.uploadSuccess"));
    } catch (e2) {
      toast.error(e2.response?.data?.detail || t("documents.failedAction"));
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">{t("documents.title")}</h2>
      <form onSubmit={upload} className="space-y-3">
        <div className="grid grid-cols-3 gap-3">
          <div>
            <Label>{t("documents.project")}</Label>
            <Select value={selectedProject} onValueChange={setSelectedProject}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {projects.map(p => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>{t("documents.type")}</Label>
            <Select value={docType} onValueChange={setDocType}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {['CONTRACT', 'OFFER', 'INVOICE', 'GRN', 'PO', 'PERMIT', 'DRAWING', 'RFI', 'DELIVERY_NOTE', 'PHOTOS'].map(typ => (
                  <SelectItem key={typ} value={typ}>{typ}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>File</Label>
            <Input type="file" accept="*" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          </div>
        </div>
        <Button type="submit" className="bg-blue-600 hover:bg-blue-700">{t("documents.uploadButton")}</Button>
      </form>
    </div>
  );
}
